import { combineReducers } from 'redux';
import login from './login';
import {LOGOUT} from '../types';




const appReducer = combineReducers({
    login
});

// persistReducer (ver redux/index.js) ya mezcla el estado rehidratado en REHYDRATE antes de
// llegar aca -- no hace falta (ni corresponde) manejarlo a mano. La version anterior lo
// desviaba a una clave "persistedState" que ningun reducer reconoce (de ahi el warning de
// combineReducers "Unexpected key persistedState... Expected... login") y la sesion
// persistida nunca se aplicaba de verdad al slice login.
const rootReducer = (state, action) => {
    if(action.type === LOGOUT){
        state = undefined;
        localStorage.removeItem('persist:root');
        localStorage.clear();
    }
    return appReducer(state, action);
}

export default rootReducer;